/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-05-19 09:48:19
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-05-19 09:53:38
 */

const state = {
  ossSign: null,
  // avatar 用户头像
  // wechat 微信头像
  // album 用户相册
  // group 用户头像
  // mall 商城图片
  ossHost: '',

  ossModuleDir: 'avatar', // 一级:模块目录modules
  ossTypeDir: '', // 二级:类型目录type

  // 是否为更新，暂时用于圈子信息修改
  update: false
}

const mutations = {

}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
